import React, { useEffect, useState } from 'react';
import Swal2 from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../styles/note_popup.css';

const MySwal = withReactContent(Swal2);

const NotePopUp = (props) => {

    return(
        <>
            <div className="mainContainerNotePopUp">
                <div className="closeButtonBoxNotePopUp">
                    <div className="closeButtonBoxNotePopUp_col1">
                        {props.type === 'note' ? 'Notatka' : 'Notatka do terminu'}
                    </div>
                    <div style={{width: "100%"}} className="closeBox">
                    <button className="closeClientButton" onClick={props.closePopUp}>X</button> 
                    </div>
                </div>
                <div className="contentBoxNotePopUp">
                    {props.content}    
                </div>
            </div>
        </>
    )

}

export default NotePopUp;